import { Eyebrow, Heading } from '#app/components/brand/section.tsx'
import { authorPersonJsonLd, buildMeta } from '#app/utils/seo.ts'
import { Footer } from '../components/footer'
import Header from '../components/header'
import { type Route } from './+types/brad-williams.ts'

const PATH = '/authors/brad-williams'

export const meta: Route.MetaFunction = () => [
	...buildMeta({
		title: 'Brad Williams | Author',
		description:
			'Brad Williams is the founder of DFW AI and the author behind Competitor Backlinks. Two decades operating businesses across law, local trades, and manufacturing.',
		path: PATH,
	}),
	{ 'script:ld+json': authorPersonJsonLd() },
]

const links = [
	{ label: 'DFW AI', href: 'https://dfwai.com/about' },
	{ label: 'YouTube', href: 'https://www.youtube.com/@dfwai_com' },
	{ label: 'X', href: 'https://x.com/DFWStrategy' },
	{ label: 'Facebook', href: 'https://www.facebook.com/dfwailabs/' },
]

export default function BradWilliams() {
	return (
		<div className="bg-canvas text-ink min-h-screen font-sans">
			<Header />

			<main>
				<section className="mx-auto max-w-[760px] px-7 pt-15 pb-11">
					<Eyebrow className="mb-5">Author</Eyebrow>
					<Heading
						as="h1"
						className="text-[clamp(34px,5vw,52px)] leading-[1.05] tracking-[-0.03em]"
					>
						Brad Williams
					</Heading>
					<p className="mt-5 max-w-[620px] text-xl leading-relaxed text-pretty text-[#57565E]">
						Founder of DFW AI. The guides, comparisons, and course here come out
						of how I actually run backlink research.
					</p>
				</section>

				<section className="[&_strong]:text-ink mx-auto max-w-[680px] px-7 text-[18.5px] leading-[1.75] text-[#33323A] [&_p]:mb-[22px] [&_strong]:font-semibold">
					<p>
						I&rsquo;m a Dallas&ndash;Fort Worth&ndash;based operator with two
						decades building and running businesses across personal injury law,
						local trades, and oil &amp; gas manufacturing. I started{' '}
						<strong>DFW AI</strong> because capable operators kept losing to
						software built for nobody in particular.
					</p>
					<p>
						Competitor Backlinks is one of those systems. The guides and course
						here document the process I actually use to read a
						competitor&rsquo;s link profile and turn it into a short list of
						links worth chasing. If a free approach is enough, they say so.
					</p>
					<p>
						You&rsquo;ll find more of how I think about AI and operating
						businesses on the DFW AI channels below.
					</p>
				</section>

				<section className="mx-auto max-w-[680px] px-7 pt-8 pb-[90px]">
					<div className="flex flex-wrap gap-3">
						{links.map((l) => (
							<a
								key={l.href}
								href={l.href}
								rel="me noopener"
								target="_blank"
								className="border-hairline hover:border-brand hover:text-brand rounded-full border bg-white px-4 py-2 font-mono text-[13.5px] transition-colors"
							>
								{l.label} &rarr;
							</a>
						))}
					</div>
				</section>
			</main>

			<Footer />
		</div>
	)
}
